import { render } from "./PopinEaster.vue?vue&type=template&id=0fa9e796"
import script from "./PopinEaster.vue?vue&type=script&lang=js"
export * from "./PopinEaster.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__